export enum SupportRequestType {
  Minor = 'minor',
  Critical = 'critical',
  Crash = 'crash',
  Other = 'other',
}

export type SupportRequestId = number | string;
